<template>
  <svg
    version="1.1"
    class="up_arrow"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 35 35"
    width="8px"
    height="8px"
    style="enable-background: new 0 0 35 35"
    xml:space="preserve"
  >
    <path
      fill="currentColor"
      d="M8.7,31.1h17.6v-13.4h6.4L17.5,3,2.2,17.7h6.4v13.4Z"
    />
  </svg>
</template>
